/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminIlvlThresholdDto,
    AdminIlvlThresholdDtoFromJSON,
    AdminIlvlThresholdDtoFromJSONTyped,
    AdminIlvlThresholdDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminConfigDto
 */
export interface AdminConfigDto {
    /**
     * 
     * @type {Array<AdminIlvlThresholdDto>}
     * @memberof AdminConfigDto
     */
    ilvlThresholds: Array<AdminIlvlThresholdDto>;
}

export function AdminConfigDtoFromJSON(json: any): AdminConfigDto {
    return AdminConfigDtoFromJSONTyped(json, false);
}

export function AdminConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminConfigDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ilvlThresholds': ((json['ilvlThresholds'] as Array<any>).map(AdminIlvlThresholdDtoFromJSON)),
    };
}

export function AdminConfigDtoToJSON(value?: AdminConfigDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ilvlThresholds': ((value.ilvlThresholds as Array<any>).map(AdminIlvlThresholdDtoToJSON)),
    };
}


